/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Letter from './Letter/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action"
  
}) {
let actionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'action',
path: 'type',
format: fromHelpers.view,
})
  return (<React.Fragment
>
<No
  viewPath={`${viewPath}/No`}
/>
<Letter
  viewPath={`${viewPath}/Letter`}
/>
{children}
</React.Fragment>)
}